import Service				from "./../../Libs/Service";

let Testing = new Service({

	Name: "Testing",

	Events: {

		"IFrame Data:MraidSDKMethodCall": function([methodName, params]) {

			this.processMraidSDKMethodCall(methodName, params);

		},

		"Refresh Iframe,Selected Version Changed": function() {

			this.clearMraidSDKSteps();

		}

	},

	Actions: {

	},

	init() {

		// Выводм и проверяем наличие этих шагов
		this.mraidSDKStepsDefinition = [
			{title: "SDK Initialized", methodName: "initialized", dependency: [{first: true}, {single: true}], primary: true, alwaysShow: true},
			{title: "MraidSDK.call('<b>Code Loaded</b>')", eventName: "Code Loaded", dependency: [{method: "initialized"}, {single: true}], primary: true, alwaysShow: true},
			{title: "MraidSDK.call('<b>Assets Loaded</b>')", eventName: "Assets Loaded", dependency: [{event: "Code Loaded"}, {single: true}], primary: true, alwaysShow: true},
			{title: "MraidSDK.<b>getSize</b>()", methodName: "getSize", dependency: [], primary: false, alwaysShow: true},
			{title: "MraidSDK.<b>viewable</b>()", methodName: "viewable", dependency: [], primary: false, alwaysShow: true},
			{title: "MraidSDK.call('<b>Game Starts</b>')", eventName: "Game Starts", dependency: [{event: "Assets Loaded"}, {single: true}], primary: true, alwaysShow: true},
			{title: "MraidSDK.<b>interaction</b>()", methodName: "interaction", dependency: [{event: "Game Starts"}], primary: true, alwaysShow: true},
			{title: "MraidSDK.call('<b>End Screen Showed</b>')", eventName: "End Screen Showed", dependency: [{event: "Assets Loaded"}], primary: false, alwaysShow: true},
			{title: "MraidSDK.<b>open</b>()", methodName: "open", dependency: [{event: "Game Starts"}], primary: true, alwaysShow: true}
		];

		this.mraidSDKSteps = [];
		this.mraidSDKEventsCalled = {};
		this.mraidSDKMethodsCalled = {};

	},

	processMraidSDKMethodCall(methodName, params) {

		let stepDefinition = null;

		if (methodName === "call") {

			stepDefinition = _.find(this.mraidSDKStepsDefinition, stepDefinition => stepDefinition.eventName === params[0]);

		} else {

			stepDefinition = _.find(this.mraidSDKStepsDefinition, stepDefinition => stepDefinition.methodName === methodName);

		}

		let error = null,
			step = null;

		if (stepDefinition) {

			let error = null;

			_.each(stepDefinition.dependency, dependency => {

				if (dependency.first && this.mraidSDKSteps.length > 0) error = `"${stepDefinition.title}" should be called first`;
				if (dependency.event && !this.mraidSDKEventsCalled[dependency.event]) error = `"${stepDefinition.title}" should be called after MraidSDK.call('<b>${dependency.event}</b>')`;
				if (dependency.method && !this.mraidSDKMethodsCalled[dependency.method]) error = `${stepDefinition.title} should be called after MraidSDK.call('<b>${dependency.method}</b>')`;

			});

			stepDefinition.passed = !error;
			stepDefinition.error = error;

		} else {

			let step = null;

			if (methodName === "call") {

				step = {
					title: params[0],
					passed: !error,
					error
				};

			} else {

				step = {
					title: methodName,
					passed: !error,
					error
				};

			}

			this.mraidSDKSteps.push(step);

		}

		if (methodName === "call") this.mraidSDKEventsCalled[params[0]] = true;
		else this.mraidSDKMethodsCalled[methodName] = true;

		Broadcast.call("Testing Step Added");

	},

	clearMraidSDKSteps() {

		this.mraidSDKSteps = [];
		this.mraidSDKEventsCalled = {};
		this.mraidSDKMethodsCalled = {};

		for (let i=0, l=this.mraidSDKStepsDefinition.length; i<l; i++) {

			let stepDefinition = this.mraidSDKStepsDefinition[i];

			delete stepDefinition.passed;
			delete stepDefinition.error;

		}

		Broadcast.call("Testing Steps Cleared");

	},

	getMraidSDKStatus() {

		let result = 'fully-passed';

		for (let i=0, l=this.mraidSDKStepsDefinition.length; i<l; i++) {

			let step = this.mraidSDKStepsDefinition[i];

			// Если хотя бы один шаг дал ошибку - возвращаем статус error
			if (step.error) result = 'error';

			// Если не выполнен важный пункт - ставим статус не пройден
			else if (step.primary && !step.passed && result !== 'error') result = 'not-passed';

			// Если не выполнен дополнительный пункт - ставим статус частично пройден
			else if (!step.primary && !step.passed && result !== 'error' && result !== 'not-passed') result = 'partially-passed';

		}

		return result;

	}

});

window.Testing = Testing;

export { Testing }

